import { render, staticRenderFns } from "./UnsettledTransactions.vue?vue&type=template&id=69dee70c&scoped=true"
import script from "./UnsettledTransactions.vue?vue&type=script&lang=js"
export * from "./UnsettledTransactions.vue?vue&type=script&lang=js"
import style0 from "./UnsettledTransactions.vue?vue&type=style&index=0&id=69dee70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dee70c",
  null
  
)

export default component.exports